import { useState } from 'react'
import { Form, Input, Button, App, Modal, Spin, Flex } from 'antd'
import { MobileOutlined, KeyOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setLogin } from '../store/loginSlice'
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons'
import { useYonghuLoginMutation, useYonghuLoginSelectMutation } from '../store/DianShangYeWuApi'
import WebFoot from './WebFoot'

function WebLogin() {
    const { message } = App.useApp();
    const prevUserPhone = JSON.parse(localStorage.getItem('jtg-caiwu_yh_phone'));
    const dispatch = useDispatch();
    const navi = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [firmList, setFirmList] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleOk = () => { setIsModalOpen(false); };
    const handleCancel = () => { setIsModalOpen(false); };

    const [passwordLoginInfo, setPasswordLoginInfo] = useState({ ba_phone: prevUserPhone })
    const [yonghuLogin] = useYonghuLoginMutation()
    const [yonghuLoginSelect] = useYonghuLoginSelectMutation()

    const handleLoginSuccess = (body) => {
        const user = body?.Result;
        if (!user || typeof user !== 'object') {
            message.error('登录失败，未返回用户信息！');
            return;
        }
        if (user.yh_state !== '1') {
            message.error('登录失败，该手机号码已被禁用！');
            return;
        }
        if (user.yh_juese !== '财务') {
            message.error('登录失败，您的岗位不是财务！');
            return;
        }
        dispatch(setLogin({
            yh_id: user.yh_id,
            yh_phone: user.yh_phone,
            yh_name: user.yh_name,
            qy_id: user.qy_id,
            qy_name: user.qy_name,
            yh_qx: user.yh_qx,
            yh_juese: user.yh_juese,
            dd_eowg_id: user.dd_eowg_id ?? null,
            dd_eowg_name: user.dd_eowg_name ?? null,
            dd_xf_num: user.dd_xf_num ?? null,
            dd_dq_date: user.dd_dq_date ?? null,
            islog: true,
        }));
        navi('/DeskHome', { replace: true });
    };

    const loginWithCompany = async (qy_id) => {
        setIsLoading(true);
        try {
            const loginResult = await yonghuLoginSelect({
                yh_mima: passwordLoginInfo.ba_pwd,
                yh_phone: passwordLoginInfo.ba_phone,
                yh_qy_id: qy_id,
                dd_eowg_id: '34',
            });
            const body = loginResult?.data;
            if (!body) {
                message.error('登录失败，服务器无响应！');
                return;
            }
            if (String(body.Status || '').toLowerCase() === 'success') {
                handleLoginSuccess(body);
            } else {
                message.error(body.Message || '登录失败，没有找到该企业！');
            }
        } catch (error) {
            console.error('登录时出错:', error);
            message.error('登录时出错');
        } finally {
            setIsLoading(false);
        }
    };

    const handleSelectCompany = (item) => {
        setIsModalOpen(false);
        loginWithCompany(item.qy_id);
    };

    const ModalSelect = (
        <Modal title="选择企业" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null}>
            <Spin spinning={isLoading}>
                <Flex vertical gap="middle">
                    {Array.isArray(firmList) && firmList.map((item) => (
                        <div key={item.qy_id}>
                            <a onClick={() => handleSelectCompany(item)} style={{ fontSize: 14 }}>
                                {item.qy_name}
                            </a>
                        </div>
                    ))}
                </Flex>
            </Spin>
        </Modal>
    );

    return (
        <div style={{
            height: '100vh',
            position: 'relative',
        }}>
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 0,
                backgroundImage: `url('./img/login.avif')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                transition: 'background-image 1s ease-in-out',
            }} />

            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1,
                backgroundColor: 'rgba(255, 255, 255, 0.2)'
            }} />

            <div style={{
                position: 'relative',
                zIndex: 2,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '20px'
            }}>
                <div style={{
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    padding: '40px',
                    borderRadius: '12px',
                    boxShadow: '0 6px 16px rgba(0, 0, 0, 0.12)',
                    width: '100%',
                    maxWidth: '420px'
                }}>
                    <div style={{
                        fontSize: "28px",
                        fontWeight: "bold",
                        textAlign: 'center',
                        marginBottom: '8px',
                        color: '#1890ff'
                    }}>旅当家2025</div>
                    <div style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        textAlign: 'center',
                        marginBottom: '8px',
                        color: '#1890ff'
                    }}>九天阁国旅</div>

                    <Form
                        name="mmlogin"
                        layout="vertical"
                        initialValues={{ remember: true }}
                        onFinish={() => {
                            yonghuLogin({
                                yh_phone: passwordLoginInfo.ba_phone,
                                yh_mima: passwordLoginInfo.ba_pwd,
                                yh_juese: '财务',
                            }).then(res => {
                                if (res.data.Status === 'success') {
                                    if (res.data.Result.length === 1) {
                                        loginWithCompany(res.data.Result[0].qy_id);
                                    } else if (res.data.Result.length > 1) {
                                        setIsModalOpen(true);
                                        setFirmList(res.data.Result.map(({ qy_id, qy_name, yh_qy_id, yh_phone }) => ({
                                            qy_id,
                                            qy_name,
                                            yh_qy_id,
                                            yh_phone,
                                        })));
                                    }
                                } else if (res.data.Status === 'fail') {
                                    message.error(res.data.Message + '用户名或密码错误！');
                                }
                            });
                        }}
                    >
                        <Form.Item
                            label="手机号码"
                            name="userPhone"
                            validateTrigger="onBlur"
                            rules={[{
                                required: true,
                                message: '请填写手机号!',
                            },
                            {
                                pattern: /^1[3-9]\d{9}$/,
                                message: '请输入正确的手机号'
                            }]}
                            initialValue={prevUserPhone}
                            style={{ marginBottom: '24px' }}
                        >
                            <Input
                                prefix={<MobileOutlined style={{ color: '#999' }} />}
                                placeholder="请输入手机号"
                                value={passwordLoginInfo.ba_phone}
                                onChange={(e) => { setPasswordLoginInfo(prevState => ({ ...prevState, ba_phone: e.target.value })) }}
                                size="large"
                                style={{ height: '40px' }}
                            />
                        </Form.Item>

                        <Form.Item
                            label="登录密码"
                            name="mm"
                            validateTrigger="onBlur"
                            rules={[
                                {
                                    required: true,
                                    message: '请填写登录密码!',
                                }]}
                            style={{ marginBottom: '32px' }}
                        >
                            <Input.Password
                                size="large"
                                placeholder='请输入登录密码'
                                prefix={<KeyOutlined style={{ color: '#999' }} />}
                                value={passwordLoginInfo.ba_pwd}
                                onChange={(e) => { setPasswordLoginInfo(prevState => ({ ...prevState, ba_pwd: e.target.value })) }}
                                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                style={{ height: '40px' }}
                            />
                        </Form.Item>

                        <Form.Item style={{ marginBottom: '16px' }}>
                            <Button
                                type='primary'
                                htmlType="submit"
                                block
                                size="large"
                                loading={isLoading}
                                style={{
                                    height: '44px',
                                    fontSize: '16px',
                                    fontWeight: '500'
                                }}
                            >
                                登录
                            </Button>
                        </Form.Item>
                    </Form>
                    {ModalSelect}

                </div>

            </div>
            <WebFoot />
        </div>
    )
}

export default WebLogin
